import { atom } from 'recoil'

export const modalMessageBeingSentState = atom({
  key: 'modalMessageBeingSentState',
  default: false
})

export const modalBeeSavedRowMetadataState = atom({
  key: 'modalBeeTemplateSavedRowMetadataState',
  default: {
    show: false,
    onConfirm: undefined,
    onCancel: undefined,
    resolveMetadata: false,
    row: undefined,
    metadata: {
      name: undefined
    },
    mode: ''
  }
})
